import React, { useState, useEffect } from "react";
import Title from "../../../../../components/common/Title/Title";
import AppRoutePath from "../../../../../router/AppRoutePath";
import Cookies from "js-cookie";
import { Button } from "react-bootstrap";
import { convertCategory, convertOutletList } from "../../../helpers/index";
import {
  AxiosCustomGet,
} from "../../../../../components/axios/AxiosCustom";
import Config from "../../../../../components/axios/Config";
import TextInput from "../../../components/TextInput";
import MultipleSelect from "../../../components/MultipleSelect";
import RadioComponent from "../../../components/RadioComponent";
import {
  chargeTime,
  dataBreadcrumb,
  dataBreadcrumbEdit,
  initChargeTime,
  pawnType,
  paymentType,
  tenorType,
} from "./constants";
import SelectCurrencyInput from "../../../components/SelectCurrencyInput";
import PromoInformation from "../../../components/PromoInformation";
import ErrorDiv from "../../../../../components/helpers/ErrorDiv";
import IsEmpty from "../../../../../components/helpers/IsEmpty";
import { useHistory } from "react-router-dom";
import httpclient from "../../../../../components/httpclient";
import SwalToast from "../../../../../components/helpers/SwalToast";
import CustomBreadcrumb from "../../../../../components/common/Breadcrumb/CustomBreadcrumb";
import NumberFormat from "react-number-format";
import { convertNotificationList } from "../../../helpers/convertNotificationGroupList";
import Select from "react-select";
import ModalSumulationInstallment from "../../../components/ModalSimulationInstallment";
import { convertDataSimulation } from "../../helpers/convertDataSimulation";

export default function AddCampaignInstallmentRegulerV2(props) {
  const history = useHistory();
  const [campaignName, setCampaignName] = useState();
  const [submitting, setSubmitting] = useState(false);
  const [categoryList, setCategoryList] = useState([]);
  const [outletList, setOutletList] = useState([]);
  const [selectedPaymentType, setSelectedPaymentType] = useState(
    paymentType[0].value
  );
  const [selectedCategory, setSelectedCategory] = useState([]);
  const [selectedOutlet, setSelectedOutlet] = useState([]);
  const [selectedPawnType, setSelectedPawnType] = useState(pawnType[0].value);
  const [tenorTypeValue, setTenorTypeValue] = useState(tenorType[0].value);
  const [chargeTimeCapitalLoan, setChargeTimeCapitalLoan] = useState(chargeTime[0].value);
  const [chargeTimeFeeAdmin, setChargeTimeFeeAdmin] = useState(chargeTime[0].value);
  const [chargeTimeFeeSavingInsurance, setChargeTimeFeeSavingInsurance] = useState(chargeTime[0].value);

  const [currencyMinLoan, setCurrencyMinLoan] = useState(props?.location?.state?.data.minLoan.includes("Rp") ? "rupiah" : "percent");
  const [minLoanValue, setMinLoanValue] = useState();
  const [currencyMaxLoan, setCurrencyMaxLoan] = useState(props?.location?.state?.data.maxLoan.includes("Rp") ? "rupiah" : "percent");
  const [maxLoanValue, setMaxLoanValue] = useState();
  const [currencyCapitalLoan, setCurrencyCapitalLoan] = useState(props?.location?.state?.data.capitalLoan.includes("Rp") ? "rupiah" : "percent");
  const [capitalLoanValue, setCapitalLoanValue] = useState();
  const [feeAdminRupiah, setFeeAdminRupiah] = useState();
  const [feeAdminPercent, setFeeAdminPercent] = useState();
  const [currencyFeeSavingInsurance, setCurrencyFeeSavingInsurance] =
    useState(props?.location?.state?.data.feeSavingInsurance.includes("Rp")
      ? "rupiah"
      : "percent");
  const [feeInsuranceValue, setFeeInsuranceValue] = useState();
  const [feeSavingValue, setFeeSavingValue] = useState();
  const [feeSavingInsuranceValue, setFeeSavingInsuranceValue] = useState();
  const [currencyLateCharge, setCurrencyLateCharge] = useState(props?.location?.state?.data.lateCharge.includes("Rp")
    ? "rupiah"
    : "percent");
  const [lateChargeValue, setLateChargeValue] = useState();
  const [currencyFeeAuction, setCurrencyFeeAuction] = useState(props?.location?.state?.data.feeAuction.includes("Rp")
    ? "rupiah"
    : "percent");
  const [feeAuctionValue, setFeeAuctionValue] = useState();
  const [currencyLateChargePeriod, setCurrencyLateChargePeriod] = useState(props?.location?.state?.data.lateChargePeriod.includes("Rp")
    ? "rupiah"
    : "percent");
  const [lateChargePeriod, setLateChargePeriod] = useState();
  const [maxLate, setMaxLate] = useState();
  const [periode, setPeriode] = useState();
  const [dayPerPeriod, setDayPerPeriod] = useState();
  const [maxAccumulativeLate, setMaxAccumulativeLate] = useState();
  const [currencyMaxAccumulativeLate, setCurrencyMaxAccumulativeLate] = useState(props?.location?.state?.data.maxAccumulativeLate.includes("Rp")
    ? "rupiah"
    : "percent");

  const [errorName, setErrorName] = useState();
  const [errorCategory, setErrorCategory] = useState();
  const [errorOutlet, setErrorOutlet] = useState();
  const [errorPawnType, setErrorPawnType] = useState();
  const [errorMinLoan, setErrorMinLoan] = useState();
  const [errorMaxLoan, setErrorMaxLoan] = useState();
  const [errorCapitalLoan, setErrorCapitalLoan] = useState();
  const [errorFeeAdmin, setErrorFeeAdmin] = useState();
  const [errorChargeLate, setErrorChargeLate] = useState();
  const [errorSaving, setErrorSaving] = useState();
  const [errorInsurance, setErrorInsurance] = useState();
  const [errorLateChargePeriod, setErrorLateChargePeriod] = useState();
  const [errorFeeAuction, setErrorFeeAuction] = useState();
  const [errorMaxLate, setErrorMaxLate] = useState();
  const [errorPeriode, setErrorPeriode] = useState();
  const [errorDayPerPeriod, setErrorDayPerPeriod] = useState();
  const [errorPaymentType, setErrorPaymentType] = useState();
  const [errorNotifGroup, setErrorNotifGroup] = useState();
  const [notificationGroups, setNotificationGroups] = useState([]);
  const [selectedNotifGroup, setSelectedNotifGroup] = useState();
  const [gracePeriod, setGracePeriod] = useState();
  const [errorGracePeriod, setErrorGracePeriod] = useState();
  const [errorMaxAccumulative, setErrorMaxAccumulative] = useState();
  const [maxBillPerPeriod, setMaxBillPerPeriod] = useState();
  const [errorMaxBillPerPeriod, setErrorMaxBillPerPeriod] = useState();
  const [modalSimulation, setModalSimulation] = useState(false);
  const [loanAmountSimulation, setLoanAmountSimulation] = useState(null);
  const [dataSimulation, setDataSimulation] = useState([]);
  const [totalSimulation, setTotalSimulation] = useState({});
  const dataEdit = props?.location?.state?.data;
  const [chargeTimeValue, setTimeChargeValue] = useState(chargeTime[0].value);

  useEffect(() => {
    getCategory();
    getOutlet();
    getNotificationGroup();
  }, []);

  useEffect(() => {
    if (!IsEmpty(feeSavingValue) && !IsEmpty(feeInsuranceValue)) {
      if (currencyFeeSavingInsurance === 'percent') {
        setFeeSavingInsuranceValue(parseFloat(feeSavingValue + feeInsuranceValue))
      } else {
        setFeeSavingInsuranceValue(parseInt(feeSavingValue + feeInsuranceValue))
      }
    }
  }, [feeSavingValue, feeInsuranceValue]);

  useEffect(() => {
    if (dataEdit) {
      let outlet = [];
      setSelectedNotifGroup(dataEdit?.notificationGroup);
      setCampaignName(dataEdit.campaignName);
      setSelectedCategory(
        dataEdit.item.promo_loan_products[0].product_category_id
      );
      setTenorTypeValue(dataEdit.item.tenor_type);
      setSelectedPaymentType(dataEdit.item.payment_type);
      dataEdit.item.promo_loan_outlets.map((item) => {
        outlet.push(item.outlet_id);
      });
      setSelectedOutlet(outlet);
      setSelectedPawnType(dataEdit.item.gadai_type);
      if (dataEdit.minLoan.includes("%")) {
        setMinLoanValue(dataEdit.item.min_loan_percentage);
      } else if (dataEdit.minLoan.includes("Rp")) {
        setMinLoanValue(dataEdit.item.min_loan_rupiah);
      }
      if (dataEdit.maxLoan.includes("%")) {
        setMaxLoanValue(dataEdit.item.max_loan_percentage);
      } else if (dataEdit.maxLoan.includes("Rp")) {
        setMaxLoanValue(dataEdit.item.max_loan_rupiah);
      }
      if (dataEdit.capitalLoan.includes("%")) {
        setCapitalLoanValue(dataEdit.item.capital_loan_percentage);
      } else if (dataEdit.capitalLoan.includes("Rp")) {
        setCapitalLoanValue(dataEdit.item.capital_loan_rupiah);
      }
      setFeeAdminPercent(dataEdit.item.fee_admin_percentage);
      setFeeAdminRupiah(dataEdit.item.fee_admin_rupiah);
      if (dataEdit?.feeSaving.includes("%")) {
        setFeeSavingValue(
          dataEdit.item.fee_saving_assurance_sharing_saving
        );
      } else if (dataEdit?.feeSaving.includes("Rp")) {
        setFeeSavingValue(dataEdit.item.fee_saving_assurance_sharing_saving_rp);
      }
      if (dataEdit?.feeInsurance.includes("%")) {
        setFeeInsuranceValue(
          dataEdit.item.fee_saving_assurance_sharing_assurance
        );
      } else if (dataEdit?.feeInsurance.includes("Rp")) {
        setFeeInsuranceValue(dataEdit.item.fee_saving_assurance_sharing_assurance_rp);
      }
      if (dataEdit.lateCharge.includes("%")) {
        setLateChargeValue(dataEdit.item.late_charge_percentage);
      } else if (dataEdit.lateCharge.includes("Rp")) {
        setLateChargeValue(dataEdit.item.late_charge_rupiah);
      }
      if (dataEdit.feeAuction.includes("%")) {
        setFeeAuctionValue(dataEdit.item.fee_auction_percentage);
      } else if (dataEdit.feeAuction.includes("Rp")) {
        setFeeAuctionValue(dataEdit.item.fee_auction_rupiah);
      }
      setMaxLate(dataEdit.item.max_late);
      setGracePeriod(dataEdit.item.grace_period);
      setPeriode(dataEdit?.item.promo_loan_tenors[0].period)
      setDayPerPeriod(dataEdit?.item.promo_loan_tenors[0].days)
      if (dataEdit.lateChargePeriod.includes("%")) {
        setLateChargePeriod(dataEdit.item.late_charge_period_percentage);
      } else if (dataEdit.lateChargePeriod.includes("Rp")) {
        setLateChargePeriod(dataEdit.item.late_charge_period_rupiah);
      }
      if (dataEdit.maxAccumulativeLate.includes("%")) {
        setMaxAccumulativeLate(dataEdit.item.max_accumulative_late_percentage);
      } else if (dataEdit.maxAccumulativeLate.includes("Rp")) {
        setMaxAccumulativeLate(dataEdit.item.max_accumulative_late);
      }
      setMaxBillPerPeriod(dataEdit.item?.max_accumulative_fee_charge)
      setChargeTimeCapitalLoan(dataEdit?.chargeTimeCapitalLoan)
      setChargeTimeFeeAdmin(dataEdit?.chargeTimeFeeAdmin)
      setChargeTimeFeeSavingInsurance(dataEdit?.chargeTimeFeeSavingInsurance)
    }
  }, []);

  const getNotificationGroup = () => {
    let url = `${process.env.REACT_APP_BASE_API_URL}notification-group/all`;
    AxiosCustomGet(
      url,
      Config({
        Authorization: `Bearer ${Cookies.get("access_token")}`,
      }),
      (response) => {
        setNotificationGroups(convertNotificationList(response.data.data));
      }
    );
  };

  const getCategory = () => {
    let url = `${process.env.REACT_APP_BASE_API_URL}product-categories`;
    AxiosCustomGet(
      url,
      Config({
        Authorization: `Bearer ${Cookies.get("access_token")}`,
      }),
      (response) => {
        setCategoryList(convertCategory(response.data.data.items));
      }
    );
  };

  const getOutlet = () => {
    let url = `${process.env.REACT_APP_BASE_API_URL}outlet`;
    AxiosCustomGet(
      url,
      Config({
        Authorization: `Bearer ${Cookies.get("access_token")}`,
      }),
      (response) => {
        setOutletList(convertOutletList(response.data.data.items));
      }
    );
  };

  const handleSelectChange = (field, data) => {
    if (field === "category") {
      setSelectedCategory(data.value);
    } else if (field === "outlet") {
      let outlet = [];
      if (data.length === 0) {
        setSelectedOutlet([]);
      } else {
        data.map((item) => {
          outlet.push({ outlet_id: item.value });
          setSelectedOutlet(outlet);
        });
      }
    } else if (field === "notification") {
      setSelectedNotifGroup(data.value);
    }
  };

  const onChangeRadio = (id, data) => {
    if (id === "paymentType") {
      setSelectedPaymentType(data.value);
    } else if (id === "tenorType") {
      setTenorTypeValue(data.value);
    } else if (id === "pawnType") {
      setSelectedPawnType(data.value);
    } else if (id === "chargeTime") {
      setTimeChargeValue(data.value);
    }
  };

  const onChangeChargeTime = (id, data) => {
    if (id === 'capitalLoan') {
      setChargeTimeCapitalLoan(data.value)
    } else if (id === 'feeAdmin') {
      setChargeTimeFeeAdmin(data.value)
    } else if (id === 'feeSavingInsurance') {
      setChargeTimeFeeSavingInsurance(data.value)
    }
  }

  const handleChangeInput = (id, data) => {
    if (data) {
      let { floatValue } = data;
      if (id === "minLoan") {
        setMinLoanValue(floatValue);
      } else if (id === "maxLoan") {
        setMaxLoanValue(floatValue);
      } else if (id === "capitalLoan") {
        setCapitalLoanValue(floatValue);
      } else if (id === "feeSaving") {
        setFeeSavingValue(floatValue);
      } else if (id === "feeInsurance") {
        setFeeInsuranceValue(floatValue);
      } else if (id === "lateCharge") {
        setLateChargeValue(floatValue);
      } else if (id === "feeAuction") {
        setFeeAuctionValue(floatValue);
      } else if (id === "lateChargePeriod") {
        setLateChargePeriod(floatValue);
      } else if (id === "maxAccumulativeLate") {
        setMaxAccumulativeLate(floatValue);
      }
    }
  };

  const handleChangeCurrency = (id, data) => {
    if (id === "minLoan") {
      setCurrencyMinLoan(data);
    } else if (id === "maxLoan") {
      setCurrencyMaxLoan(data);
    } else if (id === "capitalLoan") {
      setCurrencyCapitalLoan(data);
    } else if (id === "feeSavingInsurance") {
      setCurrencyFeeSavingInsurance(data);
    } else if (id === "lateCharge") {
      setCurrencyLateCharge(data);
    } else if (id === "feeAuction") {
      setCurrencyFeeAuction(data);
    } else if (id === "lateChargePeriod") {
      setCurrencyLateChargePeriod(data);
    } else if (id === "maxAccumulativeLate") {
      setCurrencyMaxAccumulativeLate(data);
    }
  };

  const validate = () => {
    let validate = true;
    setErrorName();
    setErrorCategory();
    setErrorOutlet();
    setErrorPawnType();
    setErrorMinLoan();
    setErrorMaxLoan();
    setErrorCapitalLoan();
    setErrorFeeAdmin();
    setErrorInsurance();
    setErrorSaving();
    setErrorChargeLate();
    setErrorLateChargePeriod();
    setErrorFeeAuction();
    setErrorMaxLate();
    setErrorPaymentType();
    setErrorNotifGroup();
    setErrorGracePeriod();
    setErrorPeriode();
    setErrorDayPerPeriod();
    setErrorMaxAccumulative();
    setErrorMaxBillPerPeriod()

    if (IsEmpty(campaignName)) {
      validate = false;
      setErrorName("Nama Harus Diisi");
    }
    if (selectedPaymentType.length === 0) {
      validate = false;
      setErrorPaymentType("Jenis Pembayaran Harus Dipilih");
    }
    if (selectedCategory.length === 0) {
      validate = false;
      setErrorCategory("Kategori Produk Harus Dipilih");
    }
    if (selectedPawnType !== "pick_up") {
      if (selectedOutlet.length === 0) {
        validate = false;
        setErrorOutlet("Outlet Harus Dipilih");
      }
    }
    if (selectedPawnType.length === 0) {
      validate = false;
      setErrorPawnType("Jenis Gadai Harus Dipilih");
    }
    if (IsEmpty(minLoanValue) && minLoanValue !== 0) {
      validate = false;
      setErrorMinLoan("Minimum Pinjaman Harus Diisi");
    }
    if (IsEmpty(maxLoanValue) && maxLoanValue !== 0) {
      validate = false;
      setErrorMaxLoan("Maksimum Pinjaman Harus Diisi");
    }
    if (IsEmpty(capitalLoanValue) && capitalLoanValue !== 0) {
      validate = false;
      setErrorCapitalLoan("Biaya Sewa Modal Harus Diisi");
    }
    if (
      (IsEmpty(feeAdminPercent) && feeAdminPercent !== 0) ||
      (IsEmpty(feeAdminRupiah) && feeAdminRupiah !== 0)
    ) {
      validate = false;
      setErrorFeeAdmin("Biaya Administrasi Harus Diisi");
    }
    if (IsEmpty(feeSavingValue) && feeSavingValue !== 0) {
      validate = false;
      setErrorSaving("Biaya Penyimpanan Harus Diisi");
    }
    if (IsEmpty(feeInsuranceValue) && feeInsuranceValue !== 0) {
      validate = false;
      setErrorInsurance("Biaya Asuransi Harus Diisi");
    }
    if (IsEmpty(lateChargeValue) && lateChargeValue !== 0) {
      validate = false;
      setErrorChargeLate("Denda Harian Harus Diisi");
    }
    if (IsEmpty(lateChargePeriod) && lateChargePeriod !== 0) {
      validate = false;
      setErrorLateChargePeriod("Biaya Keterlambatan Harus Diisi");
    }
    if (IsEmpty(feeAuctionValue) && feeAuctionValue !== 0) {
      validate = false;
      setErrorFeeAuction("Biaya Jasa Lelang Harus Diisi");
    }
    if (IsEmpty(maxLate) && maxLate !== 0) {
      validate = false;
      setErrorMaxLate("Maksimum Keterlambatan Harus Diisi");
    }
    if (IsEmpty(selectedNotifGroup)) {
      validate = false;
      setErrorNotifGroup("Notifikasi Harus Dipilih");
    }
    if (IsEmpty(gracePeriod)) {
      validate = false;
      setErrorGracePeriod("Masa Tenggang Harus Diisi");
    }
    if (IsEmpty(periode)) {
      validate = false;
      setErrorPeriode("Jumlah Periode Cicilan Harus Diisi");
    }
    if (IsEmpty(dayPerPeriod)) {
      validate = false;
      setErrorDayPerPeriod("Jumlah Hari per Periode Harus Diisi");
    }
    if (IsEmpty(maxAccumulativeLate)) {
      validate = false;
      setErrorMaxAccumulative("Maksimal Akumulasi Keterlambatan Harus Diisi");
    }
    if (IsEmpty(maxBillPerPeriod)) {
      validate = false;
      setErrorMaxBillPerPeriod("Maksimum Biaya Sewa Modal Harus Diisi");
    }
    return validate;
  };

  const onSubmit = () => {
    if (!validate()) return;
    let url = `${process.env.REACT_APP_BASE_API_URL}promo-loan/default`;
    let outlet = [];
    selectedOutlet.map((item) => {
      outlet.push({
        outlet_id: item,
      });
    });
    let data = {
      id: dataEdit?.item?.id || null,
      name: campaignName,
      payment_type: selectedPaymentType.toString(),
      tenor_type: tenorTypeValue,
      description: " ",
      max_late: parseInt(maxLate),
      max_loan_rupiah:
        currencyMaxLoan === "rupiah" ? parseInt(maxLoanValue) : 0,
      max_loan_percentage:
        currencyMaxLoan === "percent" ? parseFloat(maxLoanValue) : 0,
      min_loan_rupiah:
        currencyMinLoan === "rupiah" ? parseInt(minLoanValue) : 0,
      min_loan_percentage:
        currencyMinLoan === "percent" ? parseFloat(minLoanValue) : 0,
      fee_admin_rupiah: parseInt(feeAdminRupiah),
      fee_admin_percentage: parseFloat(feeAdminPercent),
      fee_saving_assurance_rupiah:
        currencyFeeSavingInsurance === "rupiah"
          ? parseInt(feeSavingValue)
          : 0,
      fee_saving_assurance_percentage:
        currencyFeeSavingInsurance === "percent"
          ? parseFloat(feeSavingValue)
          : 0,
      fee_auction_rupiah:
        currencyFeeAuction === "rupiah" ? parseInt(feeAuctionValue) : 0,
      fee_auction_percentage:
        currencyFeeAuction === "percent" ? parseFloat(feeAuctionValue) : 0,
      capital_loan_rupiah:
        currencyCapitalLoan === "rupiah" ? parseInt(capitalLoanValue) : 0,
      capital_loan_percentage:
        currencyCapitalLoan === "percent" ? parseFloat(capitalLoanValue) : 0,
      late_charge_rupiah:
        currencyLateCharge === "rupiah" ? parseInt(lateChargeValue) : 0,
      late_charge_percentage:
        currencyLateCharge === "percent" ? parseFloat(lateChargeValue) : 0,
      promo_loan_outlets:
        selectedPawnType === "pick_up" ? [{ outlet_id: 0 }] : outlet,
      promo_loan_products: [{ product_category_id: selectedCategory }],
      late_charge_period_percentage:
        currencyLateChargePeriod === "percent"
          ? parseFloat(lateChargePeriod)
          : 0,
      late_charge_period_rupiah:
        currencyLateChargePeriod === "rupiah" ? parseInt(lateChargePeriod) : 0,
      gadai_type: selectedPawnType.toString(),
      notification_group_id: selectedNotifGroup,
      grace_period: parseInt(gracePeriod),
      tenor_period: parseInt(periode),
      tenor_days: parseInt(dayPerPeriod),
      max_accumulative_late:
        currencyMaxAccumulativeLate === "rupiah" ? parseInt(maxAccumulativeLate) : 0,
      max_accumulative_late_percentage:
        currencyMaxAccumulativeLate === "percent" ? parseFloat(maxAccumulativeLate) : 0,
      max_accumulative_fee_charge: parseInt(maxBillPerPeriod),
      capital_loan_type: chargeTimeCapitalLoan,
      fee_admin_type: chargeTimeFeeAdmin,
      fee_saving_assurance_type: chargeTimeFeeSavingInsurance,
      fee_saving_assurance_sharing_saving_rp: currencyFeeSavingInsurance === "rupiah" ? parseInt(feeSavingValue) : 0,
      fee_saving_assurance_sharing_saving: currencyFeeSavingInsurance === "percent" ? parseInt(feeSavingValue) : 0,
      fee_saving_assurance_sharing_assurance_rp: currencyFeeSavingInsurance === "rupiah" ? parseInt(feeInsuranceValue) : 0,
      fee_saving_assurance_sharing_assurance: currencyFeeSavingInsurance === "percent" ? parseInt(feeInsuranceValue) : 0,
      interest_expense_type: chargeTimeValue,
    };
    // console.log(JSON.stringify(data)); return
    setSubmitting(true);
    if (dataEdit) {
      httpclient
        .PUT(url, data)
        .then((response) => {
          SwalToast.fire({
            icon: "success",
            title: response.data.message,
          });
          history.push(AppRoutePath.CAMPAIGN_DEFAULT, { list: 'loan_installment' });
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.data.error);
            SwalToast.fire({
              icon: "error",
              title: error.response.data.error.message,
            });
          } else {
            console.log(error);
            SwalToast.fire({
              icon: "error",
              title: "Whoops, something went wrong",
            });
          }
        })
        .finally(() => {
          setSubmitting(false);
        });
    } else {
      httpclient
        .POST(url, data)
        .then((response) => {
          SwalToast.fire({
            icon: "success",
            title: response.data.message,
          });
          history.push(AppRoutePath.CAMPAIGN_DEFAULT, { list: 'loan_installment' });
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.data.error);
            SwalToast.fire({
              icon: "error",
              title: error.response.data.error.message,
            });
          } else {
            console.log(error);
            SwalToast.fire({
              icon: "error",
              title: "Whoops, something went wrong",
            });
          }
        })
        .finally(() => {
          setSubmitting(false);
        });
    }
  };

  const handleSelectOutlet = (e) => {
    setSelectedOutlet(Array.isArray(e) ? e.map((x) => x.value) : []);
  };

  const onCalculate = () => {
    let url = `${process.env.REACT_APP_BASE_API_URL}promo-loan/calculation-installment`;
    let outlet = [];
    selectedOutlet.map((item) => {
      outlet.push({
        outlet_id: item,
      });
    });
    let data = {
      id: dataEdit?.item?.id || null,
      name: campaignName,
      payment_type: selectedPaymentType.toString(),
      tenor_type: tenorTypeValue,
      description: " ",
      max_late: parseInt(maxLate),
      max_loan_rupiah:
        currencyMaxLoan === "rupiah" ? parseInt(maxLoanValue) : 0,
      max_loan_percentage:
        currencyMaxLoan === "percent" ? parseFloat(maxLoanValue) : 0,
      min_loan_rupiah:
        currencyMinLoan === "rupiah" ? parseInt(minLoanValue) : 0,
      min_loan_percentage:
        currencyMinLoan === "percent" ? parseFloat(minLoanValue) : 0,
      fee_admin_rupiah: parseInt(feeAdminRupiah),
      fee_admin_percentage: parseFloat(feeAdminPercent),
      fee_saving_assurance_rupiah: //TODO : CHANGE FEE SAVING AND INSURANCE
        currencyFeeSavingInsurance === "rupiah"
          ? parseInt(feeSavingValue)
          : 0,
      fee_saving_assurance_percentage:
        currencyFeeSavingInsurance === "percent"
          ? parseFloat(feeSavingValue)
          : 0,
      fee_auction_rupiah:
        currencyFeeAuction === "rupiah" ? parseInt(feeAuctionValue) : 0,
      fee_auction_percentage:
        currencyFeeAuction === "percent" ? parseFloat(feeAuctionValue) : 0,
      capital_loan_rupiah:
        currencyCapitalLoan === "rupiah" ? parseInt(capitalLoanValue) : 0,
      capital_loan_percentage:
        currencyCapitalLoan === "percent" ? parseFloat(capitalLoanValue) : 0,
      late_charge_rupiah:
        currencyLateCharge === "rupiah" ? parseInt(lateChargeValue) : 0,
      late_charge_percentage:
        currencyLateCharge === "percent" ? parseFloat(lateChargeValue) : 0,
      promo_loan_outlets:
        selectedPawnType === "pick_up" ? [{ outlet_id: 0 }] : outlet,
      promo_loan_products: [{ product_category_id: selectedCategory }],
      late_charge_period_percentage:
        currencyLateChargePeriod === "percent"
          ? parseFloat(lateChargePeriod)
          : 0,
      late_charge_period_rupiah:
        currencyLateChargePeriod === "rupiah" ? parseInt(lateChargePeriod) : 0,
      gadai_type: selectedPawnType.toString(),
      notification_group_id: selectedNotifGroup,
      grace_period: parseInt(gracePeriod),
      tenor_period: parseInt(periode),
      tenor_days: parseInt(dayPerPeriod),
      max_accumulative_late:
        currencyMaxAccumulativeLate === "rupiah" ? parseInt(maxAccumulativeLate) : 0,
      max_accumulative_late_percentage:
        currencyMaxAccumulativeLate === "percent" ? parseFloat(maxAccumulativeLate) : 0,
      max_accumulative_fee_charge: parseInt(maxBillPerPeriod),
      loan_amount: loanAmountSimulation,
      capital_loan_type: chargeTimeCapitalLoan,
      fee_admin_type: chargeTimeFeeAdmin,
      fee_saving_assurance_type: chargeTimeFeeSavingInsurance,
      fee_saving_assurance_sharing_saving_rp: currencyFeeSavingInsurance === "rupiah" ? parseInt(feeSavingValue) : 0,
      fee_saving_assurance_sharing_saving: currencyFeeSavingInsurance === "percent" ? parseInt(feeSavingValue) : 0,
      fee_saving_assurance_sharing_assurance_rp: currencyFeeSavingInsurance === "rupiah" ? parseInt(feeInsuranceValue) : 0,
      fee_saving_assurance_sharing_assurance: currencyFeeSavingInsurance === "percent" ? parseInt(feeInsuranceValue) : 0,
      interest_expense_type: chargeTimeValue,
    }
    // console.log(data); return
    setSubmitting(true)
    httpclient
      .POST(url, data)
      .then((response) => {
        // console.log(response.data.data)
        setDataSimulation(convertDataSimulation(response.data.data.gadai_installment, loanAmountSimulation))
        const capitalLoan = response.data.data.gadai_installment.map(item => item.capital_loan).reduce((prev, next) => prev + next);
        const installmentAmount = response.data.data.gadai_installment.map(item => item.installment_amount).reduce((prev, next) => prev + next);
        const totalInstallment = response.data.data.gadai_installment.map(item => item.capital_loan + item.installment_amount).reduce((prev, next) => prev + next);
        setTotalSimulation({
          capitalLoan,
          installmentAmount,
          totalInstallment
        })
      })
      .catch((error) => {
        if (error.response) {
          console.log(error?.response?.data?.error);
          SwalToast.fire({
            icon: "error",
            title: error?.response?.data?.error?.message,
          });
        } else {
          console.log(error);
          SwalToast.fire({
            icon: "error",
            title: "Whoops, something went wrong",
          });
        }
      })
      .finally(() => {
        setSubmitting(false);
      });
  }

  return (
    <div className="px-3">
      <div className="pt-4 d-flex justify-content-between">
        <div className="d-flex flex-column" style={{ fontSize: "13px" }}>
          <Title text={`${dataEdit ? 'Ubah' : 'Tambah'} Reguler Offer Pinjaman Cicilan`} />
          <CustomBreadcrumb current={dataEdit ? dataBreadcrumbEdit : dataBreadcrumb} />
        </div>
      </div>
      <div className="container-campaign">
        <div className="container-input-1">
          <div className="container-input my-3">
            <TextInput
              label="Nama Promo"
              onChange={(e) => setCampaignName(e.target.value)}
              value={campaignName}
            />
            <ErrorDiv error={errorName} />
            <hr style={{ border: "1px dashed #DCDCDC" }} />
            <div className="container-sk">
              <div className="label-campaign">Syarat & Ketentuan</div>
              <div className="container-sk d-flex">
                <div className="col-6 px-0">
                  <RadioComponent
                    value={selectedPawnType}
                    options={pawnType}
                    label="Jenis Gadai"
                    onChange={onChangeRadio}
                    id="pawnType"
                  />
                </div>
              </div>
              <div className="container-sk d-flex">
                <div className="col-6 px-0">
                  <MultipleSelect
                    isMulti={false}
                    options={categoryList}
                    label="Kategori Produk"
                    id={"category"}
                    onSelectChange={handleSelectChange}
                    value={
                      selectedCategory
                        ? categoryList.find(
                          (item) => item.value === selectedCategory)
                        : null
                    }
                  />
                  <ErrorDiv error={errorCategory} />
                </div>
                <div className="col-6 pr-0">
                  <div>
                    <p>Outlet/Cabang</p>
                    <Select
                      isDisabled={selectedPawnType === "pick_up"}
                      value={outletList.filter((obj) =>
                        selectedOutlet.includes(obj.value)
                      )}
                      onChange={handleSelectOutlet}
                      closeMenuOnSelect={true}
                      isMulti={true}
                      options={outletList}
                      className="basic-multi-select"
                      styles={{
                        control: (styles) => ({
                          ...styles,
                          width: "100%",
                        }),
                        multiValue: (styles) => {
                          return {
                            ...styles,
                            backgroundColor: "#F6F6F6",
                          };
                        },
                      }}
                    />
                  </div>
                  <ErrorDiv error={errorOutlet} />
                </div>
              </div>
              <div className="container-sk d-flex">
                <div className="col-6 px-0">
                  <RadioComponent
                    value={tenorTypeValue}
                    options={tenorType}
                    label="Jenis Tenor"
                    onChange={onChangeRadio}
                    id="tenorType"
                  />
                  <ErrorDiv error={errorPawnType} />
                </div>
                <div className="col-6 px-0 ml-3">
                  <RadioComponent
                    value={selectedPaymentType}
                    options={paymentType}
                    label="Jenis Pembayaran"
                    // onChange={onChangeRadio}
                    id="paymentType"
                  />
                  <ErrorDiv error={errorPaymentType} />
                </div>
              </div>
              <div className="container-sk d-flex">
                <div className="col-6 px-0">
                  <TextInput
                    suffix="Periode"
                    label="Jumlah Periode Cicilan"
                    onChange={(e) => setPeriode(e.target.value)}
                    value={periode}
                  />
                  <ErrorDiv error={errorPeriode} />
                </div>
                <div className="col-6 pr-0">
                  <TextInput
                    suffix="Hari"
                    label="Jumlah Hari per Periode"
                    onChange={(e) => setDayPerPeriod(e.target.value)}
                    value={dayPerPeriod}
                  />
                  <ErrorDiv error={errorDayPerPeriod} />
                </div>
              </div>
              <div className="container-sk d-flex">
                <div className="col-6 px-0">
                  <RadioComponent
                    value={chargeTimeValue}
                    options={chargeTime}
                    label="Pengenaan Biaya"
                    onChange={onChangeRadio}
                    id="chargeTime"
                  />
                </div>
                <div className="col-6 pr-0">
                  <MultipleSelect
                    value={
                      selectedNotifGroup
                        ? notificationGroups.find(
                          (item) => item.value === selectedNotifGroup
                        )
                        : null
                    }
                    isMulti={false}
                    options={notificationGroups}
                    label="Notifikasi"
                    id={"notification"}
                    onSelectChange={handleSelectChange}
                  />
                  <ErrorDiv error={errorNotifGroup} />
                </div>
              </div>
            </div>
            <hr style={{ border: "1px dashed #DCDCDC" }} />
            <div className="container-sk">
              <div className="label-campaign">Promo yang Didapat</div>
              <div className="container-sk d-flex">
                <div className="col-6 px-0">
                  <SelectCurrencyInput
                    id="minLoan"
                    value={minLoanValue}
                    label="Minimum Pinjaman"
                    defaultValue={currencyMinLoan}
                    onChangeCurrency={handleChangeCurrency}
                    onChange={handleChangeInput}
                  />
                  <ErrorDiv error={errorMinLoan} />
                </div>
                <div className="col-6 pr-0">
                  <SelectCurrencyInput
                    id="maxLoan"
                    value={maxLoanValue}
                    label="Loan to Value (Maksimum Pinjaman)"
                    defaultValue={currencyMaxLoan}
                    onChangeCurrency={handleChangeCurrency}
                    onChange={handleChangeInput}
                  />
                  <ErrorDiv error={errorMaxLoan} />
                </div>
              </div>

              <div className="container-sk d-flex">
                <div className="col-6 px-0">
                  <SelectCurrencyInput
                    id="capitalLoan"
                    value={capitalLoanValue}
                    label={`Biaya Sewa Modal ${chargeTimeCapitalLoan.includes('behind') ? '(per Periode)' : ''}`}
                    defaultValue={currencyCapitalLoan}
                    onChangeCurrency={handleChangeCurrency}
                    onChange={handleChangeInput}
                  />
                  <ErrorDiv error={errorCapitalLoan} />
                </div>
                <div className="col-6 pr-0">
                  <p>Biaya Administrasi  {chargeTimeFeeAdmin.includes('behind') ? '(per Periode)' : ''}</p>
                  <div className="d-flex">
                    <div className="col-6 pl-0 d-flex align-items-center">
                      <NumberFormat
                        value={feeAdminPercent}
                        isNumericString={true}
                        onValueChange={(e) => setFeeAdminPercent(e.floatValue)}
                        thousandSeparator={"."}
                        decimalSeparator={","}
                        style={{
                          height: 32,
                          border: "0.75px solid #DCDCDC",
                          width: "100%",
                          paddingLeft: 6,
                        }}
                      />
                      <p
                        style={{ color: "#000", marginLeft: -20, marginTop: 6 }}
                      >
                        %
                      </p>
                    </div>
                    <div className="col-6 pl-1 pr-0 d-flex align-items-center">
                      <NumberFormat
                        value={feeAdminRupiah}
                        isNumericString={true}
                        onValueChange={(e) => setFeeAdminRupiah(e.floatValue)}
                        thousandSeparator={"."}
                        decimalSeparator={","}
                        style={{
                          height: 32,
                          border: "0.75px solid #DCDCDC",
                          width: "100%",
                          paddingLeft: 6,
                        }}
                      />
                      <p
                        style={{ color: "#000", marginLeft: -50, marginTop: 6 }}
                      >
                        Rupiah
                      </p>
                    </div>
                  </div>
                  <ErrorDiv error={errorFeeAdmin} />
                </div>
              </div>

              <div className="container-sk d-flex">
                <div className="col-6 px-0">
                  <SelectCurrencyInput
                    disabled={true}
                    id="feeSavingInsurance"
                    value={feeSavingInsuranceValue}
                    label={`Biaya Simpan & Asuransi  ${chargeTimeFeeSavingInsurance.includes('behind') ? '(per Periode)' : ''}`}
                    defaultValue={currencyFeeSavingInsurance}
                    onChangeCurrency={handleChangeCurrency}
                    onChange={handleChangeInput}
                  />
                </div>
                <div className="col-6 pr-0">
                  <div className="d-flex">
                    <div className="col-6 pl-0 d-flex align-items-center">
                      <p>Pembagian Biaya Simpan</p>
                    </div>
                    <div className="col-6 pl-1 d-flex align-items-center">
                      <p>Pembagian Biaya Asuransi</p>
                    </div>
                  </div>
                  <div className="d-flex">
                    <div className="col-6 pl-0 d-flex align-items-center">
                      <NumberFormat
                        value={feeSavingValue}
                        isNumericString={true}
                        onValueChange={(e) => setFeeSavingValue(e.floatValue)}
                        thousandSeparator={"."}
                        decimalSeparator={","}
                        style={{
                          height: 32,
                          border: "0.75px solid #DCDCDC",
                          width: "100%",
                          paddingLeft: 6,
                        }}
                      />
                      <p
                        style={{ color: "#000", marginLeft: currencyFeeSavingInsurance === 'percent' ? -20 : -50, marginTop: 6 }}
                      >
                        {currencyFeeSavingInsurance === 'percent' ? '%' : 'Rupiah'}
                      </p>
                    </div>
                    <div className="col-6 pl-1 pr-0 d-flex align-items-center">
                      <NumberFormat
                        value={feeInsuranceValue}
                        isNumericString={true}
                        onValueChange={(e) => setFeeInsuranceValue(e.floatValue)}
                        thousandSeparator={"."}
                        decimalSeparator={","}
                        style={{
                          height: 32,
                          border: "0.75px solid #DCDCDC",
                          width: "100%",
                          paddingLeft: 6,
                        }}
                      />
                      <p
                        style={{ color: "#000", marginLeft: currencyFeeSavingInsurance === 'percent' ? -20 : -50, marginTop: 6 }}
                      >
                        {currencyFeeSavingInsurance === 'percent' ? '%' : 'Rupiah'}
                      </p>
                    </div>
                  </div>

                  <div className="d-flex">
                    <div className="col-6 pl-0 d-flex align-items-center">
                      <ErrorDiv error={errorSaving} />
                    </div>
                    <div className="col-6 pl-1 d-flex align-items-center">
                      <ErrorDiv error={errorInsurance} />
                    </div>
                  </div>
                </div>
              </div>

              {/* <div className="container-sk d-flex">
                <div className="col-6 px-0">
                  <SelectCurrencyInput
                    id="capitalLoan"
                    value={capitalLoanValue}
                    label={`Biaya Sewa Modal ${chargeTimeCapitalLoan.includes('behind') ? '(per Periode)' : ''}`}
                    defaultValue={currencyCapitalLoan}
                    onChangeCurrency={handleChangeCurrency}
                    onChange={handleChangeInput}
                  />
                  <ErrorDiv error={errorCapitalLoan} />
                </div>
                <div className="col-6 pr-0">
                  <RadioComponent
                    value={chargeTimeCapitalLoan}
                    options={chargeTime}
                    label="Pengenaan Biaya Sewa Modal"
                    onChange={onChangeChargeTime}
                    id="capitalLoan"
                  />
                </div>
              </div>
              <div className="container-sk d-flex">
                <div className="col-6 px-0">
                  <p>Biaya Administrasi  {chargeTimeFeeAdmin.includes('behind') ? '(per Periode)' : ''}</p>
                  <div className="d-flex">
                    <div className="col-6 pl-0 d-flex align-items-center">
                      <NumberFormat
                        value={feeAdminPercent}
                        isNumericString={true}
                        onValueChange={(e) => setFeeAdminPercent(e.floatValue)}
                        thousandSeparator={"."}
                        decimalSeparator={","}
                        style={{
                          height: 32,
                          border: "0.75px solid #DCDCDC",
                          width: "100%",
                          paddingLeft: 6,
                        }}
                      />
                      <p
                        style={{ color: "#000", marginLeft: -20, marginTop: 6 }}
                      >
                        %
                      </p>
                    </div>
                    <div className="col-6 pl-1 pr-0 d-flex align-items-center">
                      <NumberFormat
                        value={feeAdminRupiah}
                        isNumericString={true}
                        onValueChange={(e) => setFeeAdminRupiah(e.floatValue)}
                        thousandSeparator={"."}
                        decimalSeparator={","}
                        style={{
                          height: 32,
                          border: "0.75px solid #DCDCDC",
                          width: "100%",
                          paddingLeft: 6,
                        }}
                      />
                      <p
                        style={{ color: "#000", marginLeft: -50, marginTop: 6 }}
                      >
                        Rupiah
                      </p>
                    </div>
                  </div>
                  <ErrorDiv error={errorFeeAdmin} />
                </div>
                <div className="col-6 pr-0">
                  <RadioComponent
                    value={chargeTimeFeeAdmin}
                    options={chargeTime}
                    label="Pengenaan Biaya Administrasi"
                    onChange={onChangeChargeTime}
                    id="feeAdmin"
                  />
                </div>
              </div>

              <div className="container-sk d-flex">
                <div className="col-6 px-0">
                  <SelectCurrencyInput
                    disabled={true}
                    id="feeSavingInsurance"
                    value={feeSavingInsuranceValue}
                    label={`Biaya Simpan & Asuransi  ${chargeTimeFeeSavingInsurance.includes('behind') ? '(per Periode)' : ''}`}
                    defaultValue={currencyFeeSavingInsurance}
                    onChangeCurrency={handleChangeCurrency}
                    onChange={handleChangeInput}
                  />
                </div>
                <div className="col-6 pr-0">
                  <RadioComponent
                    value={chargeTimeFeeSavingInsurance}
                    options={chargeTime}
                    label="Pengenaan Biaya Simpan & Asuransi"
                    onChange={onChangeChargeTime}
                    id="feeSavingInsurance"
                  />
                </div>
              </div>

              <div className="container-sk d-flex">
                <div className="col-6 px-0">
                  <div className="d-flex">
                    <div className="col-6 pl-0 d-flex align-items-center">
                      <p>Pembagian Biaya Simpan</p>
                    </div>
                    <div className="col-6 pl-1 d-flex align-items-center">
                      <p>Pembagian Biaya Asuransi</p>
                    </div>
                  </div>
                  <div className="d-flex">
                    <div className="col-6 pl-0 d-flex align-items-center">
                      <NumberFormat
                        value={feeSavingValue}
                        isNumericString={true}
                        onValueChange={(e) => setFeeSavingValue(e.floatValue)}
                        thousandSeparator={"."}
                        decimalSeparator={","}
                        style={{
                          height: 32,
                          border: "0.75px solid #DCDCDC",
                          width: "100%",
                          paddingLeft: 6,
                        }}
                      />
                      <p
                        style={{ color: "#000", marginLeft: currencyFeeSavingInsurance === 'percent' ? -20 : -50, marginTop: 6 }}
                      >
                        {currencyFeeSavingInsurance === 'percent' ? '%' : 'Rupiah'}
                      </p>
                    </div>
                    <div className="col-6 pl-1 pr-0 d-flex align-items-center">
                      <NumberFormat
                        value={feeInsuranceValue}
                        isNumericString={true}
                        onValueChange={(e) => setFeeInsuranceValue(e.floatValue)}
                        thousandSeparator={"."}
                        decimalSeparator={","}
                        style={{
                          height: 32,
                          border: "0.75px solid #DCDCDC",
                          width: "100%",
                          paddingLeft: 6,
                        }}
                      />
                      <p
                        style={{ color: "#000", marginLeft: currencyFeeSavingInsurance === 'percent' ? -20 : -50, marginTop: 6 }}
                      >
                        {currencyFeeSavingInsurance === 'percent' ? '%' : 'Rupiah'}
                      </p>
                    </div>
                  </div>

                  <div className="d-flex">
                    <div className="col-6 pl-0 d-flex align-items-center">
                      <ErrorDiv error={errorSaving} />
                    </div>
                    <div className="col-6 pl-1 d-flex align-items-center">
                      <ErrorDiv error={errorInsurance} />
                    </div>
                  </div>
                </div>
              </div> */}

              <div className="container-sk d-flex">
                <div className="col-6 px-0">
                  <SelectCurrencyInput
                    id="lateCharge"
                    value={lateChargeValue}
                    label="Denda Harian"
                    defaultValue={currencyLateCharge}
                    onChangeCurrency={handleChangeCurrency}
                    onChange={handleChangeInput}
                  />
                  <ErrorDiv error={errorChargeLate} />
                </div>
                <div className="col-6 pr-0">
                  <SelectCurrencyInput
                    id="lateChargePeriod"
                    value={lateChargePeriod}
                    label={`Biaya Keterlambatan`}
                    defaultValue={currencyLateChargePeriod}
                    onChangeCurrency={handleChangeCurrency}
                    onChange={handleChangeInput}
                  />
                  <ErrorDiv error={errorLateChargePeriod} />
                </div>
              </div>

              <div className="container-sk d-flex">
                <div className="col-6 px-0">
                  <SelectCurrencyInput
                    id="maxAccumulativeLate"
                    value={maxAccumulativeLate}
                    label="Maksimal Akumulasi Keterlambatan"
                    defaultValue={currencyMaxAccumulativeLate}
                    onChangeCurrency={handleChangeCurrency}
                    onChange={handleChangeInput}
                  />
                  <ErrorDiv error={errorMaxAccumulative} />

                </div>
                <div className="col-6 pr-0">
                  <TextInput
                    value={maxBillPerPeriod}
                    suffix="Persen"
                    label="Maksimum Biaya Sewa Modal (per Periode)"
                    onChange={(e) => setMaxBillPerPeriod(e.target.value)}
                  />
                  <ErrorDiv error={errorMaxBillPerPeriod} />

                </div>
              </div>

              <div className="container-sk d-flex">
                <div className="col-6 px-0">
                  <SelectCurrencyInput
                    id="feeAuction"
                    value={feeAuctionValue}
                    label="Biaya Jasa Lelang"
                    defaultValue={currencyFeeAuction}
                    onChangeCurrency={handleChangeCurrency}
                    onChange={handleChangeInput}
                  />
                  <ErrorDiv error={errorFeeAuction} />
                </div>
                <div className="col-6 pr-0">
                  <TextInput
                    value={maxLate}
                    suffix="Hari"
                    label="Maksimum Keterlambatan"
                    onChange={(e) => setMaxLate(e.target.value)}
                  />
                  <ErrorDiv error={errorMaxLate} />

                </div>
              </div>

              <div className="container-sk d-flex">
                <div className="col-6 px-0">
                  <TextInput
                    value={gracePeriod}
                    suffix="Hari"
                    label="Masa Tenggang"
                    onChange={(e) => setGracePeriod(e.target.value)}
                  />
                  <ErrorDiv error={errorGracePeriod} />

                </div>
                <div className="col-6 pr-0">

                </div>
              </div>
            </div>
          </div>

          <div className="ml-auto d-flex align-items-center justify-content-between">
            <Button
              disabled={submitting}
              onClick={() => setModalSimulation(true)}
              className="btn-action"
              style={{
                width: 150,
                height: 36,
                margin: 5,
                background: "#F5CB58",
                border: "0.75px solid #DCDCDC",
              }}
            >
              Simulasi Cicilan
            </Button>
            <div>
              <Button
                disabled={submitting}
                onClick={() => history.push(AppRoutePath.CAMPAIGN_DEFAULT, { list: 'loan_installment' })}
                className="btn-action"
                style={{
                  width: 120,
                  height: 36,
                  margin: 5,
                  background: "#fff",
                  border: "0.75px solid #DCDCDC",
                  color: "#2C465C",
                }}
              >
                Kembali
              </Button>
              <Button
                disabled={submitting}
                variant="primary"
                className="btn-action btn-add"
                style={{ width: 120, height: 36, margin: 5 }}
                onClick={onSubmit}
              >
                {dataEdit ? 'Simpan' : 'Tambah'}
              </Button>
            </div>
          </div>
        </div>

        <PromoInformation />
      </div>
      <ModalSumulationInstallment
        visible={modalSimulation}
        onClose={() => setModalSimulation(false)}
        data={dataSimulation}
        loanAmount={loanAmountSimulation}
        setLoanAmount={setLoanAmountSimulation}
        calculate={onCalculate}
        submitting={submitting}
        total={totalSimulation}
      />
    </div>
  );
}
